import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { getApiDirectionFromTable } from "../../../../../shared/utils/sorting";
import { Filter, SortField, WorkLogPayerTabFilterStatus } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter,
  sort?: UrlQuerySort<SortField>
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    "filter[payerId]": userId,
    "sort[updatedAt]": getApiDirectionFromTable(sort?.direction) || "desc"
  };

  if (filter?.payeeId) {
    request["filter[payeeId]"] = filter.payeeId;
  }

  if (filter?.assignmentId) {
    request["filter[payerPayeeEngagementId][=]"] = filter.assignmentId;
  }

  // Status filtering based on backend WorkLogStatus enum
  if (filter?.status) {
    switch (filter.status) {
      case WorkLogPayerTabFilterStatus.ToApprove:
        // InReview - awaiting payer approval
        request["filter[status][=]"] = WorkLogStatus.InReview;
        break;
      case WorkLogPayerTabFilterStatus.InProgress:
        // InProgress - returned for payee corrections
        request["filter[status][=]"] = WorkLogStatus.InProgress;
        break;
      case WorkLogPayerTabFilterStatus.Approved:
        request["filter[status][=]"] = WorkLogStatus.Approved;
        break;
      case WorkLogPayerTabFilterStatus.Rejected:
        request["filter[status][=]"] = WorkLogStatus.Rejected;
        break;
    }
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
